import { TreeNode } from "primereact/treenode";
import { DiagnosticsLogNode } from "../types/DiagnosticsLogNode";

export const mapDiagnosticsLogNodeToTreeNodeRecursively = (
    logNode: DiagnosticsLogNode,
): TreeNode => {
    return {
        key: logNode.id,
        data: {
            timeGenerated: logNode.timeGenerated,
            name: logNode.logInfo.name,
            duration: logNode.duration,
            operationType: logNode.operationType,
            initiator: logNode.initiator,
            success: logNode.success,
        },
        children: logNode.children
            ? logNode.children.map((child: DiagnosticsLogNode) =>
                  mapDiagnosticsLogNodeToTreeNodeRecursively(child),
              )
            : [],
    } as TreeNode;
};
